export default "__VITE_ASSET__JFGOZbFj__"